import React, { useEffect, useState } from 'react';
import CityCards from './cityCards';
import Image from 'next/image';
import { useLazyQuery } from '@apollo/client';
import CITIESMODAL from '../../api/citiesSearch';

import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import styled from 'styled-components';
const Link = dynamic(() => import('next/link'));
interface CITYMODAL {
  cities: CITY[];
}
interface CITY {
  id: string;
  name: string;
  slug: string;
  card_media: [
    {
      url: string;
      alt: string;
    }
  ];
}
const StyleDiv = styled.div`
  position: absolute;
  bottom: 18%;
  @media (max-height: 760px) {
    bottom: 10%;
  }
  @media ((max-width: 640px) and (max-height: 600px)) {
    bottom: 7%;
  }
`;
const CitiesModal = () => {
  const [getData, { data, loading }] = useLazyQuery(CITIESMODAL);
  const [showModal, setShowModal] = useState<boolean>(false);
  const router = useRouter();
  const [filteredCards, setFilteredCards] = useState<CITY[]>([]);
  const [searchItem, setSearchItem] = useState<string | undefined>();

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
      getData();
      document.dispatchEvent(
        new CustomEvent('citiesModalOpen', { detail: true })
      );
    } else {
      document.body.style.overflow = 'unset';
      document.dispatchEvent(
        new CustomEvent('citiesModalOpen', { detail: false })
      );
    }

    return () => {
      document.body.style.overflow = 'unset';
      document.dispatchEvent(
        new CustomEvent('citiesModalOpen', { detail: false })
      );
    };
  }, [showModal, getData]);
  useEffect(() => {
    if (router.isReady) {
      setShowModal(false);
    }
  }, [router.asPath, router.isReady]);

  useEffect(() => {
    if (searchItem !== undefined) {
      setFilteredCards(
        data?.findYourCity?.cities
          ?.map((item: any) => {
            if (
              item?.city?.name?.toLowerCase().includes(searchItem.toLowerCase())
            ) {
              return { ...item?.city };
            }
          })
          .filter((item: any) => item !== undefined)
      );
    }
    if (!searchItem && data && data.findYourCity.cities.length > 0) {
      setFilteredCards(
        data?.findYourCity?.cities.map((item: any) => {
          return { ...item?.city };
        })
      );
    }
  }, [searchItem, data]);

  useEffect(() => {
    if (data) {
      setFilteredCards(
        data?.findYourCity.cities.map((item: any) => {
          return { ...item.city };
        })
      );
    }
  }, [data]);

  useEffect(() => {
    setShowModal(false);
  }, [router]);

  return (
    <>
      <StyleDiv className="flex justify-center w-full">
        <button
          onClick={() => setShowModal(true)}
          className="items-center px-4 gap-3 border border-gray-400 relative w-[200px] md:w-[500px] bg-white text-white z-[39] py-2 md:py-4 text-xl flex justify-start rounded-xl"
        >
          <Image
            src="/search-icon-seesight.png"
            width={23}
            height={10}
            alt="search icon"
            className="w-4 md:w-6"
          />
          <span className="text-left text-lg text-gray-400 md:text-xl lg:text-2xl">
            Find your city
          </span>
        </button>
      </StyleDiv>

      <div
        style={{ zIndex: 1000 }}
        className={`${
          showModal ? 'flex' : 'hidden'
        } fixed min-h-screen w-full bg-white top-0 left-0 z-50 pt-24 flex flex-col overflow-y-scroll overflow-x-hidden pb-6`}
      >
        <div className="absolute flex justify-start flex-col w-full scrollbar-hide mt-4 gap-4">
          <div className="w-full px-[5%] pt-2 md:px-[10%] lg:px-[20%] flex justify-start flex-col relative items-start">
            <button
              className="border xl:border-2 absolute border-primary hover:bg-[#2E3D7A] active:bg-[#2E3D7A] w-20 xl:w-36 rounded-lg py-1 xl:py-2 text-primary hover:text-white xl:left-[8%]"
              onClick={() => setShowModal(false)}
            >
              Back
            </button>
            <div className="flex pt-12 xl:pt-0 w-full justify-between items-center">
              <h2 className="text-xl md:text-3xl text-primary">
                Find Your City
              </h2>
              <input
                className="input border-2 px-2 rounded-md w-36 md:w-[20%] py-1 md:py-2"
                onChange={e => setSearchItem(e.target.value)}
                placeholder="Search city"
              />
            </div>
          </div>
          {loading && (
            <div role="status" className="w-full flex justify-center">
              <svg
                aria-hidden="true"
                className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          )}
          <div className="grid grid-cols-2 pb-6 px-[5%] md:grid-cols-3 2xl:grid-cols-4 4xl:grid-cols-5 w-full md:px-[10%] lg:px-[20%] gap-4">
            {!loading &&
              filteredCards?.map(city => {
                if (!city.card_media) return;

                return (
                  <Link
                    href={`/${city.slug}`}
                    className="cols-span-1 h-full min-h-[155px] max-h-[155px] rounded-md relative"
                    key={city.name}
                  >
                    <CityCards
                      name={city.name}
                      slug={city.slug}
                      image={city?.card_media[0]?.url}
                      alt={city.name}
                    />
                  </Link>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};

export default CitiesModal;
